import React from 'react';

import useTranslate from "../../../../common/hooks/useTranslate";

import {GridColumnMenuFilter, GridColumnMenuProps} from "@progress/kendo-react-grid";

import './columnMenu.scss';

const ColumnMenu = (props: GridColumnMenuProps) => {
  const {t} = useTranslate();

  return (
    <div className='column-menu-wrapper'>
      <span className='filter-text'>{t('FILTERS.FILTER_TEXT')}</span>
      <GridColumnMenuFilter {...props} hideSecondFilter={true} expanded={true}/>
    </div>
  );
};

export default ColumnMenu;